/*
 * A rota da página de busca e o endereço dela. Fora da SearchPage para a
 * página ir num chunk próprio: o link do modal só precisa da URL.
 */
import app from 'flarum/forum/app';
import { forumBool } from '../../../utils/settings';
export const SEARCH_ROUTE = 'canela.search';
export function searchPageEnabled() {
  return forumBool('canelaSearchPageEnabled', true);
}

/** URL da página de busca — usada pelo link do modal e por quem mais quiser. */
export function searchUrl(q, type, sort) {
  const params = {};
  if (q) params.q = q;
  if (type && type !== 'topics') params.type = type;
  if (sort && sort !== 'relevance') params.sort = sort;
  return app.route(SEARCH_ROUTE, params);
}
flarum.reg.add('ramon-canela', 'forum/features/extras/search/route', { SEARCH_ROUTE: SEARCH_ROUTE,searchPageEnabled: searchPageEnabled,searchUrl: searchUrl, });